import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface TodayProgress {
  activitiesCompleted: number;
  pointsEarned: number;
  timeSpent: number;
}

export function useTodayProgress(childId: string | null) {
  const [todayProgress, setTodayProgress] = useState<TodayProgress>({
    activitiesCompleted: 0,
    pointsEarned: 0,
    timeSpent: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchTodayProgress = async () => {
    if (!childId) {
      setTodayProgress({
        activitiesCompleted: 0,
        pointsEarned: 0,
        timeSpent: 0,
      });
      return;
    }

    setLoading(true);
    try {
      const today = new Date().toISOString().split('T')[0];
      
      const { data, error } = await supabase
        .from('child_progress')
        .select('points_earned, time_spent')
        .eq('child_id', childId)
        .gte('completed_at', `${today}T00:00:00.000Z`)
        .lt('completed_at', `${today}T23:59:59.999Z`);

      if (error) throw error;

      const progress = data || [];
      const activitiesCompleted = progress.length;
      const pointsEarned = progress.reduce((sum, p) => sum + (p.points_earned || 0), 0);
      const timeSpent = progress.reduce((sum, p) => sum + (p.time_spent || 0), 0);

      setTodayProgress({
        activitiesCompleted,
        pointsEarned,
        timeSpent,
      });
    } catch (error) {
      console.error('Error fetching today progress:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodayProgress();
  }, [childId]);

  return {
    todayProgress,
    loading,
    refetch: fetchTodayProgress,
  };
}